var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_DIGITAL_GIFT_CARDS_SETTINGS, SET_PROCESSED_GIFT_CARD_PAYMENT, SET_CREDIT_CARD_REQUEST_STATUS, } from "actions/digital_gift_cards";
import { RequestStatus } from "types/requests";
var initialState = {
    settingsRequest: { type: RequestStatus.NOT_STARTED },
    orderRequest: { type: RequestStatus.NOT_STARTED },
    afterProcessedPaymentRequest: { type: RequestStatus.NOT_STARTED },
    creditCardRequestStatus: RequestStatus.NOT_STARTED,
};
function digitalGiftCardsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_DIGITAL_GIFT_CARDS_SETTINGS: {
            return __assign(__assign({}, state), { settingsRequest: action.settings });
        }
        case SET_PROCESSED_GIFT_CARD_PAYMENT: {
            return __assign(__assign({}, state), { afterProcessedPaymentRequest: action.processedGiftCardPayment });
        }
        case SET_CREDIT_CARD_REQUEST_STATUS: {
            return __assign(__assign({}, state), { creditCardRequestStatus: action.status });
        }
        default:
            return state;
    }
}
export default digitalGiftCardsReducer;
